import React  from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY, AUTH_PREFIX_PATH, SUPPORT_HELP_PUBLIC_PATH } from 'configs/AppConfig'

/** Public paths that must render even when a session token exists (auth screens, marketing, etc.) */
const unRestructesRoutes = [
	'/',
	'/pricing',
	SUPPORT_HELP_PUBLIC_PATH,
	'/app/about',
	'/app/contact',
	'/app/help',
	'/health',
	`${AUTH_PREFIX_PATH}/login`,
	`${AUTH_PREFIX_PATH}/login-1`,
	`${AUTH_PREFIX_PATH}/login-2`,
	`${AUTH_PREFIX_PATH}/forgot-password`,
	'/auth/reset-password',
	'/user-reset-password',
	'/forget-reset-password',
	'/payment/success',
	'/payment/cancel',
	'/payment/status',
	'/payment/debug',
	'/payment/test-route',
	'/payment/direct-test',
]

const PublicRoute = ({ children }) => {

	const { token } = useSelector(state => state.auth)
	const location = useLocation();

	if(unRestructesRoutes.includes(location.pathname.toLowerCase())){
		return children;
	}

	return token ? <Navigate to={AUTHENTICATED_ENTRY} replace /> : children

}

export default PublicRoute